export class Xliff {
  public id?: string = '';
  public version: number = null;
  public source: string = '';
  public note: string = '';
  public created_by: string = '';
  public last_updated_by: string = '';
  public created_ts: number = null;
  public last_updated_ts: number = null;
  public ar_SA: string = '';
  public cs: string = '';
  public da: string = '';
  public de: string = '';
  public en_GB: string = '';
  public es_419: string = '';
  public es: string = '';
  public fi: string = '';
  public fr_CA: string = '';
  public fr: string = '';
  public he: string = '';
  public it: string = '';
  public ja: string = '';
  public ko: string = '';
  public nb: string = '';
  public nl: string = '';
  public pl: string = '';
  public pt_BR: string = '';
  public pt_PT: string = '';
  public ru: string = '';
  public sv: string = '';
  public tr_TR: string = '';
  public zh_Hans: string = '';
  public zh_Hant: string = '';
}
